import { BaseRouteService } from "core/services";

class FacilityInventoryCountHeaderRouteService extends BaseRouteService {
	constructor() {
		super("facility-inventory-count-headers");	
	}	
	
	find(filter) {
		return super.find(`${this.base}/{?searchQuery,page,rpp,sort,embed,fields,facilityId,authorId,countDate}`, filter);
	}	
	
	get(id, options) {		
		return super.get(`${this.base}/{id}{?embed,fields}`, id, options);	
	}
	
	create(resource) {		
		return super.create(this.base, resource);	
	}

	createFacilityInventoryCountHeaderAndDetails(resource) {		
		return super.create(`${this.base}/create-facility-inventory-count-header-and-details`, resource);	
	}

	createNikoFacilityInventoryCountHeaderAndDetails(resource) {		
		return super.create(`${this.base}/create-niko-facility-inventory-count-header-and-details`, resource);	
	}

	update(resource) {
		return super.update(`${this.base}/{id}`, resource);	
	}

	delete(resource) {
        return super.delete(this.base + '/{id}', resource);
    }

	changeIsDone(resource) {
        return super.update(this.base + '/{id}/change-is-done/{isDone}', resource);
    }

	uploadFile(facilityInventoryCountHeaderId, formData) {
		return super.update(`${this.base}/{id}/upload-file`, { id: facilityInventoryCountHeaderId, formData});
	}
		
}

export default FacilityInventoryCountHeaderRouteService;
